<div class="iconsWrapper">
    <label class="uneditableFormLabel">{{ "MODULE_ICON_LIST.SELECT_ICON" | translate }}</label>
    <div role="radiogroup" [attr.aria-label]="'MODULE_ICON_LIST.SELECT_ICON' | translate">
        @for (icon of allIcons; track $index) {
            <div
                class="gridLike"
                [class.selected]="(selected || 0) == icon.key"
                [attr.aria-label]="icon.name"
                [attr.tabindex]="(selected || 0) == icon.key ? 0 : -1"
                (click)="iconClick(icon.key)"
                (keydown)="onKeydown($event, $index)">
                <itv-module-icon
                    [iconid]="icon.key"
                    [color]="selected == icon.key ? 'white' : 'black'"></itv-module-icon>
            </div>
        }
    </div>
</div>
